import styled from 'styled-components';

export const Container = styled.div`
  border: 1px solid #666;
  border-radius: 32px;
  overflow: hidden;
  display: flex;
  height: 40px;
  /* margin-right: 1rem; */

  input,
  button {
    height: 100%;
  }

  input {
    width: 40px !important;
  }

  button {
    width: 44px;
  }

  &.small {
    height: 30px;
    input {
      height: 100%;
      width: 40px !important;
    }
    button {
      height: 100%;
      width: 24px;
    }
  }
`;

export const Input = styled.input`
  border: 0 !important;
  border-radius: initial !important;
  flex: 1;
  padding: 0px 6px !important;
  margin: 0 !important;

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }

  & {
    -moz-appearance: textfield;
  }
`;

const Button = styled.button`
  color: #666;
  background: white;
  border: 0;

  &:hover {
    text-decoration: none !important;
  }
`;

export const Decrease = styled(Button)`
  border-right: 1px solid;
`;

export const Increase = styled(Button)`
  border-left: 1px solid;
`;
